/**
 * @generated SignedSource<<8eefffb770c376eb82455e0d47b84009>>
 * @relayHash 11ce33df0e31c52950aa35b62b331009
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 69d939c305c08c86e8ab85db73769cddd5f12ba8cc655bb192aadb5737584e8b

import type { ConcreteRequest } from 'relay-runtime';
export type StatusAndApprovalsConfigSetApprovalsMutation$variables = {
  cloudId: string;
  enabled: boolean;
  spaceKey: string;
};
export type StatusAndApprovalsConfigSetApprovalsMutation$data = {
  readonly confluence_setContentApprovalsSpaceSettings: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly isContentApprovalsEnabled: boolean | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type StatusAndApprovalsConfigSetApprovalsMutation = {
  response: StatusAndApprovalsConfigSetApprovalsMutation$data;
  variables: StatusAndApprovalsConfigSetApprovalsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "enabled",
    "variableName": "enabled"
  },
  {
    "kind": "Variable",
    "name": "spaceKey",
    "variableName": "spaceKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "success"
},
v5 = {
  "kind": "ScalarField",
  "name": "isContentApprovalsEnabled"
},
v6 = {
  "kind": "ScalarField",
  "name": "message"
},
v7 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StatusAndApprovalsConfigSetApprovalsMutation",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "ConfluenceContentApprovalsSpaceSettingsPayload",
        "kind": "LinkedField",
        "name": "confluence_setContentApprovalsSpaceSettings",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "StatusAndApprovalsConfigSetApprovalsMutation",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "ConfluenceContentApprovalsSpaceSettingsPayload",
        "kind": "LinkedField",
        "name": "confluence_setContentApprovalsSpaceSettings",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "11ce33df0e31c52950aa35b62b331009",
    "id": "69d939c305c08c86e8ab85db73769cddd5f12ba8cc655bb192aadb5737584e8b",
    "metadata": {},
    "name": "StatusAndApprovalsConfigSetApprovalsMutation",
    "operationKind": "mutation",
    "text": "mutation StatusAndApprovalsConfigSetApprovalsMutation($cloudId:ID!,$spaceKey:String!,$enabled:Boolean!){confluence_setContentApprovalsSpaceSettings(cloudId:$cloudId,spaceKey:$spaceKey,enabled:$enabled){success,isContentApprovalsEnabled,errors{message,extensions{__typename,errorType,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "69f9fa52fe38b61631c5e3e1a7f9e59c";

export default node;
